import { render, staticRenderFns } from "./ServicepointEditPage.vue?vue&type=template&id=0f351240&scoped=true"
import script from "./ServicepointEditPage.vue?vue&type=script&lang=ts"
export * from "./ServicepointEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f351240",
  null
  
)

export default component.exports